/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';

export const Selector = styled.div`
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  scroll-snap-align: center;
`;

export const Numerator = styled.div`
  display: flex;
  place-content: center;
  place-items: center;

  border-radius: 50%;

  height: 30px;
  width: 30px;
  padding-top: 6px;

  color: ${({ theme }) => theme.colors.lightGray};

  border: 1px solid white;

  margin-right: 12px;

  ${({ isActivated, theme }) =>
    isActivated &&
    css`
      background-color: white;
      color: ${theme.colors.lightBlue};
    `}

  ${({ brokeState, theme }) =>
    brokeState &&
    css`
      background-color: ${theme.colors.darkYellow};
      border-color: ${theme.colors.darkYellow};
      color: #fff;
    `}

    ${({ isAccept, theme }) =>
    isAccept &&
    css`
      background-color: ${theme.colors.darkGreen};
      border-color: ${theme.colors.darkGreen};
    `}

    ${({ errorState, theme }) =>
    errorState &&
    css`
      background-color: ${theme.colors.red};
      border-color: ${theme.colors.red};
      color: #fff;
    `}

    svg {
    margin-bottom: 0 !important;
    height: 18px;
    width: 18px;
    font-size: 1.125rem;
  }
`;

export const Label = styled.span`
  place-self: center;

  color: ${({ theme }) => theme.colors.lightGray};

  ${({ isActivated, theme }) =>
    isActivated &&
    css`
      color: white;
    `}

  ${({ isAccept, theme }) =>
    isAccept &&
    css`
      color: white;
    `}
`;

export const Container = styled.div`
  font-size: 0.9375rem;
  margin: 0 42px;

  display: grid;
  grid-template-columns: 1fr;
  row-gap: 21px;

  scroll-snap-type: x mandatory;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    overflow-y: hidden;
    margin-top: 171px;
    margin-bottom: 12px;
    ${Selector} {
      margin-right: 18px;
    }

    ${Selector}:first-child {
      margin-left: 100px;
    }
  }

  &::-webkit-scrollbar {
    opacity: 0;
  }
`;
